<template>
  <v-container fluid class="dataset-detail" v-if="dataset">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{ name: 'rbu-dataset', params: { datasetId: dataset.id } }"
      >
        <h3 class="font-weight-regular">&lt;&lt; Dataset Issue List</h3>
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>

    <v-row class="dataset-info-wrapper">
      <v-col cols="12">
        <div class="dataset-info">
          <h3>[{{ datasetTypesString }}] {{ dataset.title }}</h3>
          <h5>Ignore Sync List - {{ $parsePeriod(issue.period) }}</h5>
        </div>
      </v-col>
    </v-row>

    <v-row class="flex-grow-1 rounded-b">
      <DatasetIgnoreList
        :extra-filters="{
          dataset_id: [$route.params.datasetId],
          issue_id: [$route.params.issueId],
        }"
        :refresh-trigger.sync="datasetIgnoreListRefreshTrigger"
      ></DatasetIgnoreList>
    </v-row>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import { computed, onMounted, ref } from "@vue/composition-api";
import DatasetIgnoreList from "@/components/dataset/DatasetIgnoreList.vue";
import ImportDatasetDialog from "@/components/rbu/ImportDatasetDialog.vue";
import ImportDatasetExcelDialog from "@/components/rbu/ImportDatasetExcelDialog.vue";

export default {
  name: "DatasetIgnore",
  components: { DatasetIgnoreList },
  setup(props, { root }) {
    const dataset = ref(null);
    const issue = ref(null);

    const datasetTypesString = computed(() => {
      if (dataset.value) {
        return dataset.value.types.map((t) => t.name).join(", ");
      }

      return "";
    });

    const getDataset = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/",
        params: {
          dataset_id: root.$route.params.datasetId,
        },
      });

      if (response.body.success) {
        dataset.value = response.body.dataset;
      }
    };

    const getIssue = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/issue/",
        params: { issue_id: root.$route.params.issueId },
      });

      if (response.body.success) {
        issue.value = response.body.issue;
      }
    };

    const datasetIgnoreListRefreshTrigger = ref(false);

    onMounted(() => {
      getDataset();
      getIssue();
    });

    return {
      dataset,
      datasetTypesString,
      issue,
      datasetIgnoreListRefreshTrigger,
    };
  },
};
</script>
